import * as eventTypes from '../../../../js/document/event-types'
import { accommodationPracticalBlockMapper } from '../mappers/accommodation-practical-block/accommodation-practical-block-mapper'
import pusher from '../pusher'

export function listenCollapseEvents (event, track) {
  event.on(eventTypes.collapseEvents.OPEN, (data) => {
    const mappedData = accommodationPracticalBlockMapper(data, eventTypes.collapseEvents.OPEN, track)
    pusher.pushDataObject(mappedData)
  })

  event.on(eventTypes.collapseEvents.CLOSE, (data) => {
    const mappedData = accommodationPracticalBlockMapper(data, eventTypes.collapseEvents.CLOSE, track)
    pusher.pushDataObject(mappedData)
  })
}
